import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupPopupsComponent } from './group-popups.component';
import { SimpleSelectModule } from '../simple-select/simple-select.module';
import { GroupMembersModule } from '../group-members/group-members.module';
import { GroupScoreboardModule } from '../group-scoreboard/group-scoreboard.module';
import { GroupWaitingModule } from '../group-waiting/group-waiting.module';



@NgModule({
    declarations: [
        GroupPopupsComponent
    ],
    imports: [
        CommonModule,
        SimpleSelectModule,
        GroupMembersModule,
        GroupScoreboardModule,
        GroupWaitingModule
    ],
    exports: [
        GroupPopupsComponent
    ]
})
export class GroupPopupsModule { }
